import apiClient from '../apiClient';
import { GET_RESTAURANT_ITEM_EXPORT_DATA_URL } from '../apiUrl';

const getExportRestaurantItemApi = () => {
  return apiClient.get(GET_RESTAURANT_ITEM_EXPORT_DATA_URL);
};

export default getExportRestaurantItemApi;
